export const notificationsConstants = {
  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  FETCH_NOTIFICATIONS_FAILURE: 'FETCH_NOTIFICATIONS_FAILURE',
  UPDATE_NOTIFICATION_STATUS: 'NOTIFICATION_UPDATE_STATUS',
  FETCH_SERVICES_NOTIFICATIONS_SUCCESS: 'FETCH_SERVICES_NOTIFICATIONS_SUCCESS',
  FETCH_SERVICES_NOTIFICATIONS_FAILURE: 'FETCH_SERVICES_NOTIFICATIONS_FAILURE',
  UPDATE_SERVICES_NOTIFICATIONS_DISPLAY_STATUS: 'UPDATE_SERVICES_NOTIFICATIONS_DISPLAY_STATUS'
};
